import request from "./request";
import Cookies from 'js-cookie';

// 登录页登录
export function login(data) {
  return request({
    url: "/apipad.php/Login/uchecklogin",
    method: "post",
    data,
  });
}

// 后台进入登录
export function login_pc(data) {
  return request({
    url: "/apipad.php/Login/ucheckloginc",
    method: "post",
    data,
  });
}


export function logout(token) {
  return request({
    url: "/apipad.php/Login/Login_out",
    method: "post",
    data: { token }
  });
}

// 管理员入口密码验证
export function check(data) {
  return request({
    url: "/apipad.php/Login/check_pass",
    method: "post",
    data,
  });
}

// 测试
export function aaa(data) {
  return request({
    url: "/api.php?c=KuerpWarehouse&a=index",
    method: "post",
    data,
  });
}

//登录页面logo
export function getLoginLogo() {
  return request({
    url: "/apipad.php/Login/Systemcc",
    method: "post",
  });
}

//Token缓存
const TokenKey = 'p_token'
export function setToken(token) {
  if (token) {
    Cookies.set(TokenKey, token)
  } else {
    Cookies.remove(TokenKey)
  }
}

export function getToken() {
  return Cookies.get(TokenKey)
}

const TokenCCKey = 'p_token_cc'
export function setTokenCC(token) {
  if (token) {
    Cookies.set(TokenCCKey, token)
  } else {
    // Cookies.remove(TokenCCKey)
  }
}

export function getTokenCC() {
  return Cookies.get(TokenCCKey)
}

const UserInfoKey = 'p_user_info'
export function setUserInfo(userInfo) {
  if (userInfo) {
    Cookies.set(UserInfoKey, userInfo)
  } else {
    Cookies.remove(UserInfoKey)
  }
}

export function getUserInfo() {
  const string = Cookies.get(UserInfoKey)
  if (string) {
    return JSON.parse(string)
  }
  return {}
}

